import cristi from '../../assets/team/cristi.png';
import cornel from '../../assets/team/cornel.png';
import rares from '../../assets/team/rares.png';

export interface TeamMember {
    name: string;
    role: string;
    year: number;
    photo: string;
}

export const members: TeamMember[] = [
    {
        name: 'Cornel Sculean',
        role: 'Director, Ghid de Turism',
        year: 2010,
        photo: cornel
    },
    {
        name: 'Rareș Popa',
        role: 'Director adjunct, Ghid de Turism',
        year: 2012,
        photo: rares
    },
    {
        name: 'Cristian Hilohi',
        role: 'Informatician, Însoțitor grup',
        year: 2013,
        photo: cristi
    },
]